import { render, staticRenderFns } from "./trueFalseQuestion.vue?vue&type=template&id=bfa14d84&"
import script from "./trueFalseQuestion.vue?vue&type=script&lang=js&"
export * from "./trueFalseQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa14d84')) {
      api.createRecord('bfa14d84', component.options)
    } else {
      api.reload('bfa14d84', component.options)
    }
    module.hot.accept("./trueFalseQuestion.vue?vue&type=template&id=bfa14d84&", function () {
      api.rerender('bfa14d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/trueFalseQuestion.vue"
export default component.exports